import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import TaxonomyLookupModalFooter from './Components/TaxonomyLookupModalFooter';
import TaxonomyLookupModalHeader from './Components/TaxonomyLookupModalHeader';
import TaxonomyLookupModalContent from './Components/TaxonomyLookupModalContent';
import './TaxonomyLookupModal.custom.scss';

const spinnerId = 'taxonomy-lookup-spinner';

function TaxonomyLookupModal(props) {
  const { close, init, isLoading } = props;

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GeneralDialogLayout
      selfClose={close}
      className="react-dialogs-scrollable taxonomyLookupModal"
      size="xl"
      movable={false}
      header={<TaxonomyLookupModalHeader {...props} />}
      footer={<TaxonomyLookupModalFooter {...props} />}>
      <>
        {isLoading && <SimpleSpinner id={spinnerId} />}
        <TaxonomyLookupModalContent {...props} />
      </>
    </GeneralDialogLayout>
  );
}

TaxonomyLookupModal.propTypes = {
  isLoading: PropTypes.bool,
  init: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};

export default TaxonomyLookupModal;
